import React from "react";
import { styled } from "@mui/material/styles";

const Container = styled("div")({
  maxWidth: "1400px",
  margin: "0 auto",
  backgroundColor: "white",
  padding: "30px",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
});

const Title = styled("h1")({
  textAlign: "center",
  fontSize: "28px",
  fontWeight: 600,
  color: "#1a1a1a",
  marginBottom: "15px",
});

const CurrencyNote = styled("p")({
  textAlign: "center",
  fontSize: "14px",
  color: "#666",
  marginTop: "10px",
  fontStyle: "italic",
});

const StyledTable = styled("table")({
  width: "100%",
  borderCollapse: "collapse",
  marginTop: "20px",
  fontSize: "14px",
  "& th, & td": {
    border: "1px solid #ddd",
    padding: "12px 15px",
    textAlign: "center",
  },
  "& th": {
    backgroundColor: "#f8f9fa",
    fontWeight: 600,
    color: "#1a1a1a",
  },
  "& .header-row": {
    backgroundColor: "#e9ecef",
  },
  "& .country-column": {
    textAlign: "left",
    fontWeight: 500,
  },
  "& .plan-header": {
    backgroundColor: "#f8f9fa",
    fontSize: "16px",
    fontWeight: 600,
    padding: "15px",
  },
  "& .amount-header": {
    backgroundColor: "#f8f9fa",
    fontWeight: 600,
    verticalAlign: "middle",
  },
  "& tbody tr:nth-of-type(even)": {
    backgroundColor: "#fafafa",
  },
  "& tbody tr:hover": {
    backgroundColor: "#f0f0f0",
  },
  "@media (max-width: 1200px)": {
    fontSize: "12px",
    "& th, & td": {
      padding: "8px 10px",
    },
  },
  "@media (max-width: 768px)": {
    fontSize: "11px",
    "& th, & td": {
      padding: "6px 8px",
    },
  },
});

const pricingData = [
  { country: "Argentina", starter: [5.028, 2.478, 2.097], growth: [4.982, 2.383, 2.097], pro: [4.937, 2.287, 2.097] },
  { country: "Brazil", starter: [5.085, 0.648, 0.548], growth: [5.039, 0.623, 0.548], pro: [4.993, 0.598, 0.548] },
  { country: "Chile", starter: [7.230, 1.905, 1.612], growth: [7.165, 1.832, 1.612], pro: [7.100, 1.758, 1.612] },
  { country: "Colombia", starter: [1.017, 0.076, 0.065], growth: [1.008, 0.074, 0.065], pro: [0.999, 0.071, 0.065] },
  { country: "Egypt", starter: [5.238, 0.343, 0.290], growth: [5.191, 0.330, 0.290], pro: [5.144, 0.317, 0.290] },
  { country: "France", starter: [6.992, 2.859, 2.419], growth: [6.929, 2.749, 2.419], pro: [6.866, 2.639, 2.419] },
  { country: "Germany", starter: [11.108, 5.242, 4.435], growth: [11.008, 5.040, 4.435], pro: [10.908, 4.839, 4.435] },
  { country: "India", starter: [0.958, 0.150, 0.127], growth: [0.949, 0.144, 0.127], pro: [0.941, 0.138, 0.127], highlight: true },
  { country: "Indonesia", starter: [3.342, 2.381, 2.015], growth: [3.312, 2.290, 2.015], pro: [3.282, 2.198, 2.015] },
  { country: "Israel", starter: [2.872, 0.505, 0.427], growth: [2.846, 0.486, 0.427], pro: [2.820, 0.466, 0.427] },
  { country: "Italy", starter: [5.618, 2.857, 2.417], growth: [5.568, 2.747, 2.417], pro: [5.517, 2.637, 2.417] },
  { country: "Malaysia", starter: [6.997, 1.334, 1.129], growth: [6.934, 1.283, 1.129], pro: [6.871, 1.231, 1.129] },
  { country: "Mexico", starter: [2.482, 0.809, 0.685], growth: [2.459, 0.778, 0.685], pro: [2.437, 0.747, 0.685] },
  { country: "Netherlands", starter: [12.996, 4.765, 4.032], growth: [12.879, 4.582, 4.032], pro: [12.762, 4.399, 4.032] },
  { country: "Nigeria", starter: [4.201, 0.639, 0.541], growth: [4.164, 0.614, 0.541], pro: [4.126, 0.590, 0.541] },
  { country: "Pakistan", starter: [3.850, 0.515, 0.436], growth: [3.815, 0.495, 0.436], pro: [3.780, 0.475, 0.436] },
  { country: "Peru", starter: [5.720, 1.906, 1.613], growth: [5.669, 1.833, 1.613], pro: [5.617, 1.759, 1.613] },
  { country: "Russia", starter: [6.523, 3.810, 3.224], growth: [6.464, 3.664, 3.224], pro: [6.406, 3.517, 3.224] },
  { country: "Saudi Arabia", starter: [3.695, 1.018, 0.862], growth: [3.662, 0.979, 0.862], pro: [3.629, 0.940, 0.862] },
  { country: "South Africa", starter: [3.088, 0.725, 0.614], growth: [3.060, 0.697, 0.614], pro: [3.032, 0.669, 0.614] },
  { country: "Spain", starter: [5.000, 1.904, 1.611], growth: [4.955, 1.831, 1.611], pro: [4.910, 1.758, 1.611] },
  { country: "Turkey", starter: [0.887, 0.505, 0.427], growth: [0.879, 0.486, 0.427], pro: [0.871, 0.466, 0.427] },
  { country: "United Arab Emirates", starter: [4.064, 1.496, 1.266], growth: [4.027, 1.439, 1.266], pro: [3.991, 1.381, 1.266] },
  { country: "United Kingdom", starter: [4.301, 2.096, 1.773], growth: [4.262, 2.015, 1.773], pro: [4.223, 1.935, 1.773] },
  { country: "North America", starter: [2.033, 0.324, 0.274], growth: [2.014, 0.311, 0.274], pro: [1.996, 0.299, 0.274] },
  { country: "Rest of Africa", starter: [1.831, 0.381, 0.322], growth: [1.815, 0.366, 0.322], pro: [1.798, 0.352, 0.322] },
  { country: "Rest of Asia Pacific", starter: [5.957, 1.077, 0.911], growth: [5.903, 1.035, 0.911], pro: [5.849, 0.994, 0.911] },
  { country: "Rest of Central & Eastern Europe", starter: [6.993, 2.014, 1.705], growth: [6.930, 1.937, 1.705], pro: [6.867, 1.860, 1.705] },
  { country: "Rest of Latin America", starter: [6.017, 1.076, 0.911], growth: [5.963, 1.035, 0.911], pro: [5.909, 0.993, 0.911] },
  { country: "Rest of Middle East", starter: [2.774, 0.866, 0.733], growth: [2.749, 0.833, 0.733], pro: [2.724, 0.800, 0.733] },
  { country: "Rest of Western Europe", starter: [4.815, 1.627, 1.377], growth: [4.772, 1.565, 1.377], pro: [4.728, 1.502, 1.377] },
  { country: "Other", starter: [4.912, 0.733, 0.621], growth: [4.867, 0.705, 0.621], pro: [4.823, 0.677, 0.621] },
];

const WhatsappPricingTable: React.FC = () => {
  return (
    <div style={{ padding: "20px", backgroundColor: "#f5f5f5", minHeight: "calc(100vh - 70px)" }}>
      <Container>
        <Title>Country Wise WhatsApp Message Cost (Based on the type of template)</Title>
        <CurrencyNote>Amount in INR (Applicable to Indian numbers)</CurrencyNote>

        <StyledTable>
          <thead>
            <tr className="header-row">
              <th rowSpan={2} className="amount-header">
                To Recipient
                <br />
                Country
              </th>
              <th colSpan={3} className="plan-header">
                Starter Plan
              </th>
              <th colSpan={3} className="plan-header">
                Growth Plan
              </th>
              <th colSpan={3} className="plan-header">
                Pro Plan
              </th>
            </tr>
            <tr className="header-row">
              <th>Marketing</th>
              <th>Utility</th>
              <th>Authentication</th>
              <th>Marketing</th>
              <th>Utility</th>
              <th>Authentication</th>
              <th>Marketing</th>
              <th>Utility</th>
              <th>Authentication</th>
            </tr>
          </thead>
          <tbody>
            {pricingData.map((row, index) => (
              <tr key={index} style={row.highlight ? { fontWeight: "bold" } : {}}>
                <td className="country-column" style={row.highlight ? { fontWeight: "bold" } : {}}>
                  {row.country}
                </td>
                <td>{row.starter[0]}</td>
                <td>{row.starter[1]}</td>
                <td>{row.starter[2]}</td>
                <td>{row.growth[0]}</td>
                <td>{row.growth[1]}</td>
                <td>{row.growth[2]}</td>
                <td>{row.pro[0]}</td>
                <td>{row.pro[1]}</td>
                <td>{row.pro[2]}</td>
              </tr>
            ))}
          </tbody>
        </StyledTable>
      </Container>
    </div>
  );
};

export default WhatsappPricingTable;
